<template>
  <v-container fluid>
    <v-dialog
      persistent
      v-model="modalOk"
      :active="modalOk"
      :on-cancel="
        () => {
          modalOk = false
        }
      "
    >
      <form @submit.prevent="Save">
        <v-card>
          <v-toolbar dark color="darkblue">
            <v-toolbar-title> Map Classes</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn icon dark @click="modalOk = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text>
            <v-container fluid>
                <v-col cols="12">
                <v-container>
                  <v-row v-for="k in classTypeData" :key="k.type">
                    <v-col cols=12 md="2" v-if="k.type !== null">
                      <label class="font-weight-bold body-2" style="color:red; margin-top:16px; display: inline-block;"> {{k.type}}</label>
                    </v-col>
                    <v-col cols=12 md="10">
                    <v-row no-gutters>
                      <v-col cols="12" md="3" v-for="c in classData" :key="c.id">
                        <v-checkbox v-model="selectedClasses" :value="c.id" :label="c.name" checked="true" v-if="k.type === c.type && k.type !== null"> </v-checkbox>
                      </v-col>
                    </v-row>
                    </v-col>
                  </v-row>
                </v-container>

 <v-container>
                <v-row>
                  <v-col cols=12 md="2">
                    <label class="font-weight-bold body-2" style="color:red; margin-top:16px; display: inline-block;">OTHER</label>
                  </v-col>
                   <v-col cols=12 md="10">

                    <v-row no-gutters>
                      <v-col cols="12" md="3" v-for="c in classData" :key="c.id">
                        <v-checkbox v-model="selectedClasses" :value="c.id" :label="c.name" checked="true" v-if="c.type === null"> </v-checkbox>
                      </v-col>
                    </v-row>
                   </v-col>
                    </v-row>
                    </v-container>

                  </v-col>

                  <!-- <v-row>
                    <label class="font-weight-bold body-2" style="color:red;">OTHER</label>
                  </v-row>
                    <v-row no-gutters>
                      <v-col cols="12" md="3" v-for="c in classData" :key="c.id">
                        <v-checkbox v-model="selectedClasses" :value="c.id" :label="c.name" checked="true" v-if="c.type === null"> </v-checkbox>
                      </v-col>
                    </v-row>

                  </v-col> -->

                <v-col cols="12">
                  <v-divider></v-divider>
                  <v-card-actions class="justify-end">
                    <v-btn
                      @click="
                        () => {
                          clrModalData(), (modalOk = false), (academicYearID = ''), (selectedClasses = []), (sectionID = []), (sectionarray = [])
                        }
                      "
                      >Close</v-btn
                    >
                    <v-btn @click="mapSave" color="primary">Save</v-btn>
                  </v-card-actions>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </form>
    </v-dialog>
    <material-card icon="mdi-clipboard-text" inline title="Class group List">
      <v-card-text class="pt-0 pr-1" :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
        <v-card-title>
          <!-- Total Records : {{ total }} -->
          <v-spacer></v-spacer>
        </v-card-title>
        <v-text-field
          :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
          v-model="search"
          append-icon="mdi-magnify"
          class="ml-auto mb-2"
          label="Search"
          hide-details
          single-line
          style="max-width:350px;"
        />
        <v-btn v-if="isWrite" elevation="1" v-on:click="addClass()" :class="{ 'mt-2': $vuetify.breakpoint.xs }" color="accent">
          <v-icon left>mdi-plus</v-icon>
          Add
        </v-btn>
      </v-card-text>
      <v-divider class=" my-0 " />
      <v-data-table
        :search.sync="search"
        :footer-props="{
          'items-per-page-options': [5, 10, 20, 40]
        }"
        :items-per-page="10"
        :headers="headers"
        :items="searchFilterArray"
      >

        <template v-slot:item.isActive="{ item }">
          {{ item.isActive ? 'Active' : 'Inactive' }}
        </template>
        <template v-if="isWrite" v-slot:item.actions="{ item }">
<router-link v-if="isWrite" :to="{ name: 'classGroupEdit', params: { classGroupID: item.id } }">
                <v-btn outlined color="success" class="px-2 ml-1 ma-1" min-width="0" small>
                  Edit Class Group
                </v-btn>
              </router-link>

          <v-btn outlined @click="modalOpen(item.id)" class="px-2 ml-1 ma-1" color="accent" min-width="0" small>
            Add Class
          </v-btn>
        </template>
        <template v-slot:no-data>
          <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
        </template>
      </v-data-table>
    </material-card>

    <loading-icon :value="isLoading" />
  </v-container>
</template>
<script>
import constants from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'
import Utils from '@/utils'
import _ from 'lodash'
export default {
  name: 'classGroupList',
  components: { MaterialCard },
  data () {
    return {
      classGroupData: [],
      classData: [],
      selectedClasses: [],
      search: '',
      isLoading: false,
      searchTerm: '',
      total: '',
      modalOk: false,
      sectionName: '',
      approveAction: null,
      selectedClass: '',
      selectedClassGroupID: '',
      isWrite: false,
      searchFilterArray: [],
      mappingData: [],
      classTypeData: [],
      headers: [
        { text: 'Name', sortable: true, value: 'name' },
        { text: 'Classes', sortable: true, value: 'classes' },
        { text: 'Type', sortable: true, value: 'type' },
        { text: 'Active/Inactive', sortable: true, value: 'isActive' },
        { text: 'Action', sortable: false, value: 'actions', align: 'center' }
      ],
      viewModalOk: false
    }
  },
  created: async function () {
    await this.getClassGroupData()
    await this.getClasses()
    await this.getClassTypes()
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
  },
  mounted: async function () {
    await this.getClassGroupData()
    await this.getClasses()
    await this.getClassTypes()
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
  },
  methods: {

    getSelectedClassGroupMapping: async function (classGroupID) {
      this.hasClicked = true
      this.loader = true
      try {
        const { data } = await http.get(`${constants.API_URL}/api/student/get-selected-classgroup-mapping/${classGroupID}`)
        this.mappingData = data
        let selectedClassObj = this.selectedClasses
        if (this.mappingData) {
          const objectArray = Object.entries(this.mappingData)
          objectArray.forEach(([key, value]) => {
            selectedClassObj.push(value.classID)
          })

          this.classData.filter(function (e) {
            if (selectedClassObj.includes(e.id)) {
              e.isCheck = true
            } else {
              e.isCheck = false
            }
            return e
          })
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting Class Group Mapping: ${errorMessage}`)
      }
    },
    customSearch: function (value) {
      if (_.isEmpty(value)) {
        this.searchFilterArray = this.classGroupData
        this.total = this.searchFilterArray.length
      } else {
        this.searchFilterArray = _.filter(
          this.classGroupData,
          item => (item && item.name.toLowerCase().search(value.toLowerCase()) >= 0) || item.studentSections.some(a => a.name.toLowerCase().search(value.toLowerCase()) >= 0)
        )
        this.total = this.searchFilterArray.length
      }
    },
    modalOpen: async function (id) {
      this.modalOk = true
      this.selectedClassGroupID = id
      await this.getSelectedClassGroupMapping(id)
    },
    getClassGroupData: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/student/getclass-group`)
        this.total = data.length
        this.classGroupData = data

        this.classGroupData.filter(function (e) {
          let classObj = []
          if (e.studentClassGroupsMaps && e.studentClassGroupsMaps) {
            const objectArray = Object.entries(e.studentClassGroupsMaps)
            objectArray.forEach(([key, value]) => {
              value.studentClasses.filter(function (k) {
                classObj.push(k.name)
              })
            })
            e.classes = classObj
          }
          return e
        })

        this.searchFilterArray = this.classGroupData
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
        this.errMsg(`Error While getting Data: ${errorMessage}`)
      } finally {
        this.isLoading = false
      }
    },
    getClasses: async function () {
      try {
        const { data } = await http.get(`${constants.API_URL}/api/student/get-all-classes`)
        this.total = data.length
        this.classData = data
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    getClassTypes: async function () {
      try {
        const { data } = await http.get(`${constants.API_URL}/api/student/get-all-classtypes`)
        this.total = data.length
        this.classTypeData = data
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    addClass () {
      this.$router.push({ name: 'addClassGroup' })
    },
    mapSave: async function () {
      try {
        this.isLoading = true
        await http.post(`${constants.API_URL}/api/student/class-group-map`, {
          classes: this.selectedClasses,
          classGroupID: this.selectedClassGroupID
        })
        this.modalOk = false
        await this.getClassGroupData()
        this.okMsg('Class assigned successfully!')
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
        this.selectedClasses = []
        this.sectionID = []
        this.sectionarray = []
        this.clrModalData()
      }
    },
    okMsg (msg) {
      return this.$buefy.dialog.alert({
        type: 'is-success',
        message: msg,
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },
    clrModalData () {
      this.viewModalOk = false
      this.classMapData = []
      this.selectedClasses = []
      this.sectionarray = []
      this.selectedClassGroupID = ''
    },
    errMsg (msg) {
      return this.$buefy.dialog.alert({
        message: msg,
        type: 'is-danger',
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    }
  }
}
</script>
